import { graphql } from "gatsby"
import React from "react"
import {
  Base,
  Box, Button, Container, Flex,
  Heading, HeroBody, Section,
  Text
} from "./ui"
import * as styles from "./ui.css"
import ReactHtmlParser from 'react-html-parser'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function CTA(props) {
  return (
    <Base as="div" cx={[styles.ctaSection]}>
      <Flex cx={[styles.ctaFlex]} gap={0}>
        <Base as="div" cx={[styles.ctaSectionLeft]}>
          <Base as="div" cx={[styles.ctaOuterImages]} id={'heroOuterImages'} {...props}>
            <Base as="div" cx={[styles.ctaSubOuterImages]} id={'heroSubOuterImages'} {...props}>
              {props.floatingImage1 && (
                <Base
                  as={GatsbyImage}
                  placeholder='none'
                  alt={props.floatingImage1.alt}
                  image={getImage(props.floatingImage1.gatsbyImageData)}
                  className={[styles.floatingImage1Image]}
                />
              )}
              {props.floatingImage2 && (
                <Base
                  as={GatsbyImage}
                  placeholder='none'
                  alt={props.floatingImage2.alt}
                  image={getImage(props.floatingImage2.gatsbyImageData)}
                  className={[styles.floatingImage2Image]}
                />
              )}
              {props.floatingImage3 && (
                <Base
                  as={GatsbyImage}
                  placeholder='none'
                  alt={props.floatingImage3.alt}
                  image={getImage(props.floatingImage3.gatsbyImageData)}
                  className={[styles.floatingImage3Image]}
                />
              )}
              {props.floatingImage4 && (
                <Base
                  as={GatsbyImage}
                  placeholder='none'
                  alt={props.floatingImage4.alt}
                  image={getImage(props.floatingImage4.gatsbyImageData)}
                  className={[styles.floatingImage4Image]}
                />
              )}
              {props.image && (
                <Base
                  as={GatsbyImage}
                  placeholder='none'
                  alt={props.image.alt}
                  image={getImage(props.image.gatsbyImageData)}
                  className={[styles.ctaImage]}
                />
              )}
            </Base>
          </Base>
        </Base>
        <Base as="div" cx={[styles.ctaSectionRight]}>
          <Text as="h1" variant={'heading2'}>
            {ReactHtmlParser(props.heading)}
          </Text>
          <Text variant="subhead2">
            {props.text}
          </Text>
        </Base>
      </Flex>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageCtaContent on HomepageCta {
    id
    heading
    kicker
    text
    image {
      id
      gatsbyImageData
      alt
    }
    floatingImage1 {
      id
      gatsbyImageData
      alt
    }
    floatingImage2 {
      id
      gatsbyImageData
      alt
    }
    floatingImage3 {
      id
      gatsbyImageData
      alt
    }
    floatingImage4 {
      id
      gatsbyImageData
      alt
    }
  }
`
